var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 144,
    viewBox: "0 0 163 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91863 19.9367L20.2238 52.1718C23.5403 58.3496 29.6029 62.5764 36.5464 63.552L84.0303 70.2233C85.2944 70.4009 86.7861 71.0529 86.8152 72.3292C86.8498 73.8439 85.124 74.6158 83.622 74.8145L36.7892 81.0072C29.7092 81.9434 23.5241 86.258 20.2006 92.5792L2.93353 125.421C1.01642 129.067 -0.245962 133.302 1.12336 137.187C2.18084 140.188 3.98872 141.951 6.89868 143.079C10.7229 144.562 14.9882 143.622 18.74 141.964L153.807 82.2941C157.213 80.7893 160.557 78.6099 161.896 75.1356C162.994 72.288 162.638 69.8665 161.02 67.1053C159.323 64.2106 156.402 62.3003 153.329 60.9543L19.6805 2.4256C15.3429 0.526029 10.2772 -0.418815 6.11295 1.8356C3.51231 3.24351 1.85651 5.21847 0.917547 8.40797C-0.222212 12.2795 1.00971 16.3808 2.91863 19.9367Z",
    fill: "#01030F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.1d899b9b566f6d7c364bfa218b7ea5e3.svg";
export { ForwardRef as ReactComponent };